import { h } from 'preact';
import { TextFieldEntry, TextAreaEntry } from '@epx/flow';

export class SfdBusinessRuleExtension {
  constructor(lf, i18n) {
    this._lf = lf;
    this._i18n = i18n;
  }

  isApplicable(elementType) {
    return elementType === 'epx:BusinessRuleTask';
  }

  getGroups(element) {
    const lf = this._lf;
    const i18n = this._i18n;
    const props = element.properties || {};
    const id = element.id;

    const update = (key, value) => {
      lf.setProperties(id, { [key]: value });
      lf.emit('node:properties-change', { id, properties: { [key]: value } });
    };

    const entries = [
      {
        id: 'decisionRef',
        component: () => (
          <TextFieldEntry
            id="sfd-decisionRef"
            label={i18n.decisionRef || 'Decision Reference'}
            value={props.decisionRef || ''}
            placeholder="ej: evaluarCredito"
            description={i18n.decisionRefDesc || 'ID de la Decision Table en el BRMS'}
            debounce={300}
            onChange={val => update('decisionRef', val)}
          />
        ),
      },
      {
        id: 'resultVariable',
        component: () => (
          <TextFieldEntry
            id="sfd-resultVariable"
            label={i18n.resultVariable || 'Result Variable'}
            value={props.resultVariable || ''}
            placeholder="ej: decision"
            description={i18n.resultVariableDesc || 'Variable del proceso donde se guarda el resultado'}
            debounce={300}
            onChange={val => update('resultVariable', val)}
          />
        ),
      },
      {
        id: 'openDmnEditor',
        component: () => (
          <div class="sfd-brms-btn-wrap">
            <button
              class="sfd-brms-open-btn"
              onClick={() => {
                if (typeof window.openDmnPanel === 'function') {
                  window.openDmnPanel(id, props.decisionRef);
                }
              }}
            >
              <svg width="13" height="13" viewBox="0 0 13 13" fill="none">
                <rect x="1" y="1" width="11" height="9" rx="1.5" stroke="currentColor" strokeWidth="1.2"/>
                <line x1="1" y1="5" x2="12" y2="5" stroke="currentColor" strokeWidth="1"/>
                <line x1="5" y1="5" x2="5" y2="10" stroke="currentColor" strokeWidth="1"/>
              </svg>
              Editar Decision Table
              <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                <path d="M2 5h6M5 2l3 3-3 3" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            {!props.decisionRef && (
              <p class="sfd-brms-hint">
                Completa el <em>Decision Reference</em> para vincular una Decision Table.
              </p>
            )}
          </div>
        ),
      },
      {
        id: 'dmnXml',
        component: () => (
          <TextAreaEntry
            id="sfd-dmnXml"
            label={i18n.dmnXml || 'DMN XML'}
            value={props.dmnXml || ''}
            rows={10}
            disabled={true}
            placeholder={i18n.dmnXmlEmpty
              || 'Aún no se han guardado reglas. Edita la Decision Table y cierra el panel para guardar.'}
            description={i18n.dmnXmlDesc
              || 'XML de la tabla de decisión (solo lectura). Se guarda junto al BPMN al exportar.'}
          />
        ),
      },
    ];

    return [
      {
        id: 'sfdBusinessRule',
        label: i18n.sfdBusinessRule || 'Decision Rule (BRMS)',
        isEdited: () => !!(props.decisionRef || props.resultVariable),
        entries,
      },
    ];
  }
}
